import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M6.5 6.25a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0m5.5 7a9.51 9.51 0 0 0-9.5 9.5.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5 9.51 9.51 0 0 0-9.5-9.5"
    }, null, -1)
  ]));
}
const User = { render };
export {
  User as default,
  render
};
//# sourceMappingURL=User.svg.js.map
